/** Returns true only when background polling can produce a user-visible update. */
export function canPoll(
  doc: Pick<Document, 'hidden'> = document,
  network: Pick<Navigator, 'onLine'> = navigator,
): boolean {
  return !doc.hidden && network.onLine;
}
